import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js/instance/trim';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import React__default, { useState, useRef } from 'react';
import classNames from 'classnames';
import useUnmount from 'react-use/lib/useUnmount';
import '@babel/runtime-corejs3/core-js/promise';
import '@babel/runtime-corejs3/core-js/instance/concat';
import '@bilibili-maoer/web-utils';
import 'lodash-es';
import { ECaptchaType } from '../../types.js';
import '../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../utils/style.js';
import { SlideCheckModal } from '../slide-check-modal/index.js';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js/instance/includes';
import 'react-dom';
import { useGeetest } from '../../../../captcha/use-geetest.js';
import { toggleToast } from '../../../../toast/index.js';
import { sendCode, ESendCodeMessageType } from '../../../api/captcha.js';
import 'qs';
import '@babel/runtime-corejs3/core-js/reflect/construct';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/helpers/assertThisInitialized';
import '@babel/runtime-corejs3/helpers/inherits';
import '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import '@babel/runtime-corejs3/helpers/getPrototypeOf';
import '@babel/runtime-corejs3/core-js/instance/map';
import '@babel/runtime-corejs3/core-js/set-immediate';
import { DEFAULT_REGION } from '../../../utils/constants.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js/parse-int';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var COUNTDOWN_INTERVAL = 200;
var LegacyCaptchaArea = function LegacyCaptchaArea(props) {
  var account = props.account,
      captchaType = props.captchaType,
      check = props.check,
      className = props.className,
      disabledCaptcha = props.disabledCaptcha,
      type = props.type,
      identifyCodeError = props.identifyCodeError,
      region = props.region,
      onSendCodeError = props.onSendCodeError,
      onInputChange = props.onInputChange;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      countdown = _useState4[0],
      setCountdown = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      sending = _useState6[0],
      setSending = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      slideCheckModalVisible = _useState8[0],
      setSlideCheckModalVisible = _useState8[1];

  var _useGeetest = useGeetest({
    type: type
  }),
      verify = _useGeetest.verify;

  var countdownTimer = useRef(null);
  var slideBarRef = useRef(null);
  var isVerifying = useRef(false);

  var handleInputChange = function handleInputChange(e) {
    var _context;

    var value = _trimInstanceProperty(_context = e.target.value).call(_context);

    setInputValue(value);
    onInputChange(value);
  };

  var clearTimer = function clearTimer() {
    if (countdownTimer.current) {
      window.clearInterval(countdownTimer.current);
      countdownTimer.current = null;
    }
  };
  /**
   * 后端开启跳过验证后，不再验证 token 字段，可以不传 captcha_token
   */


  var handleSendCode = function handleSendCode(params) {
    setSending(true);
    sendCode(_objectSpread({
      login_name: account,
      post_type: type,
      region: (region === null || region === void 0 ? void 0 : region.code) || DEFAULT_REGION.code
    }, params)).then(function () {
      setSending(false);
      setCountdown(60);
      var targetTime = Date.now() + 60 * 1000;
      countdownTimer.current = window.setInterval(function () {
        var currentTime = Date.now();
        var remainingSeconds = Math.max(0, Math.ceil((targetTime - currentTime) / 1000));
        setCountdown(remainingSeconds);

        if (remainingSeconds <= 0) {
          clearTimer();
        }
      }, COUNTDOWN_INTERVAL);
    }).catch(function (err) {
      var _err$response;

      setSending(false);

      if (!(err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.info)) {
        if (onSendCodeError) {
          onSendCodeError({
            type: -1,
            message: '发送失败，请重试'
          });
        } else {
          toggleToast('发送失败，请重试');
        }

        return;
      }

      var errorInfo = err.response.info[0] || err.response.info;

      if (onSendCodeError) {
        onSendCodeError(errorInfo);
        return;
      }

      if (errorInfo.type === ESendCodeMessageType.ShowCaptcha) {
        if (slideBarRef.current) {
          slideBarRef.current.reset();
        }
      }

      toggleToast(errorInfo.message);
    });
  };

  var handleSendClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!check() || isVerifying.current)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!disabledCaptcha) {
                _context2.next = 5;
                break;
              }

              handleSendCode();
              return _context2.abrupt("return");

            case 5:
              isVerifying.current = true; // 滑动验证

              if (!(captchaType === ECaptchaType.NoCaptcha)) {
                _context2.next = 9;
                break;
              }

              setSlideCheckModalVisible(true);
              return _context2.abrupt("return");

            case 9:
              // geetest 验证
              verify().then(function (res) {
                if (res.success) {
                  handleSendCode({
                    captcha_token: res.captcha_token
                  });
                } else if (res.reason !== 'cancelled') {
                  console.error(res.message || '未知错误');
                }
              }).finally(function () {
                isVerifying.current = false;
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee);
    }));

    return function handleSendClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSlideCheckClose = function handleSlideCheckClose() {
    isVerifying.current = false;
    setSlideCheckModalVisible(false);
  };

  var handleSlideCheckSuccess = function handleSlideCheckSuccess(auth) {
    if (!auth) {
      return;
    }

    handleSlideCheckClose();
    handleSendCode(_objectSpread({
      captcha_token: auth.captcha_token
    }, auth.result));
  };

  useUnmount(clearTimer);

  var renderBtnText = function renderBtnText() {
    if (sending) {
      return '发送中...';
    }

    return countdown > 0 ? "\u91CD\u65B0\u83B7\u53D6 (".concat(countdown, "s)") : '获取验证码';
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(prependPrefix('legacy-captcha-area'), className)
  }, captchaType === ECaptchaType.NoCaptcha && slideCheckModalVisible && /*#__PURE__*/React__default.createElement("div", {
    className: "slide-check-modal-container"
  }, /*#__PURE__*/React__default.createElement(SlideCheckModal, {
    darkMode: props.darkMode,
    onSuccess: handleSlideCheckSuccess,
    onClose: handleSlideCheckClose,
    onRef: function onRef(ref) {
      slideBarRef.current = ref;
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "verification-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames('verification-input', {
      error: !!identifyCodeError
    })
  }, /*#__PURE__*/React__default.createElement("i", null), /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
    value: inputValue,
    onChange: handleInputChange
  }), identifyCodeError && /*#__PURE__*/React__default.createElement("div", {
    className: "form-error-msg"
  }, identifyCodeError)), /*#__PURE__*/React__default.createElement("div", {
    className: classNames('btn-get-code', {
      disabled: sending || countdown > 0
    }),
    onClick: handleSendClick
  }, renderBtnText())));
};

export { LegacyCaptchaArea };
